export default class TickerClock {

    private readonly onTick: () => void;
    private readonly tickDuration: number;
    private interval: number | undefined;

    constructor(tickDuration: number, onTick: () => void) {
        this.onTick = onTick;
        this.tickDuration = tickDuration;
    }

    public start() {
        this.interval = window.setInterval(this.onTick, this.tickDuration);
    }

    public stop() {
        if (this.interval) clearInterval(this.interval);
    }

}